import {renderToString} from 'react-dom/server'
import {SeriesPointPopout} from './series_point_popout'

export const renderPopout = ({apexContext, formatTitle, formatSeriesLabel, formatSeriesValue, ExtraContent}) => {
	const {series: valuesBySeries, dataPointIndex: seriesPointIndex, w: apexObject} = apexContext
	const seriesPointContext = {seriesPointIndex, apexObject}
	const extraContent = ExtraContent && <ExtraContent {...seriesPointContext} />

	return renderToString(
		<SeriesPointPopout
			{...seriesPointContext}
			valuesBySeries={valuesBySeries}
			formatTitle={formatTitle}
			formatSeriesLabel={formatSeriesLabel}
			formatSeriesValue={formatSeriesValue}
			extraContent={extraContent}
		/>,
	)
}
